var _ = require('lodash');


/*
NOTES:
    All functions should take the following function params.
    @param {Array} listings
    @param {Array} params - The search params a user has saved

    They will also always return an Array
    @returns {Array}

    All functions should take into account if the filter param
    they need doesn't exist it should return the listings without
    modification.
*/

var listingFilters = {
    /*
    Removes any listings by checking the listing description against
    the keywords search filter param

    @function filterByKeywordsMatchList
    */

    filterByKeywordsMatchList: function filterByKeywordsMatchList(listings, params) {
        var filtered = listings;
        var keywordsParam = _.find(params, { name: 'keywords' });

        if(
            filtered &&
            angular.isArray(filtered) &&
            filtered.length > 0 &&
            keywordsParam &&
            keywordsParam.value &&
            angular.isArray(keywordsParam.value) &&
            keywordsParam.value.length > 0
        ) {
            var keywordsMatchList = keywordsParam.value;

            angular.forEach(keywordsMatchList, function (keyword, i) {
                if(keyword && keyword.length > 0) {
                    filtered = filtered.filter(function (listing) {
                        var normalizedKeyword = _normalizeString(keyword);
                        var normalizedDescription = _normalizeString(listing.description);

                        if(normalizedKeyword && normalizedKeyword.length > 0) {
                            return normalizedDescription && normalizedDescription.indexOf(normalizedKeyword) > -1;
                        } else {
                            // invalid keyword or no alphanumeric characters so we don't consider it
                            return true;
                        }
                    });
                }
            }, keywordsMatchList);
        }

        return filtered;

        // Internal Functions
        function _normalizeString (str) {
            var normalized = null;
            if(str) {
                normalized = str.toLowerCase();
                normalized = normalized.replace(/\s*-\s*/gi, ' '); // replace hyphens with spaces
                normalized = normalized.replace(/[^0-9a-z\s]/gi, ''); // remove all NON alphanumeric and NON space chars
            }
            return normalized;
        }
    },


    /*
    Removes any listings that do not match the selected
    price with a +/- 20% leeway.

    @function filterByPrice
    */

    filterByPrice: function filterByPrice(listings, params) {
        var priceParam = _.find(params, { name: 'price' });
        var maxPercentVarient = 20;

        if(!priceParam) return listings;

        return _.filter(listings, function (listing) {
            var percent = Math.abs(Math.round(listing.price / priceParam.value * 1000) / 10 - 100).toFixed(1);

            return percent <= maxPercentVarient;
        });
    },


    /*
    Removes any homes that do not match the home type value

    @function filterByHomeType
    */

    filterByHomeType: function filterByHomeType(listings, params) {
        var homeTypeParam = _.find(params, { name: 'hometype' });
        var attachedHomeTypes = [
            'townhouse',
            'triplex',
            'quadraplex',
            'condominium',
            'apartment',
            'duplex',
            'other'
        ];
        var detachedHomeTypes = [
            'single family detached'
        ];

        if(!homeTypeParam || !homeTypeParam.value) return listings;

        return _.filter(listings, function (listing) {
            if(homeTypeParam.value === 'attached') {
                try {
                    return Boolean(~attachedHomeTypes.indexOf(listing.sub_type.toLowerCase()));
                } catch (err) {
                    return false;
                }
            } else {
                try {
                    return Boolean(~detachedHomeTypes.indexOf(listing.sub_type.toLowerCase()));
                } catch (err) {
                    return false;
                }
            }
        });
    },


    /*
    Removes all listings that do not match the
    story params value.

    @function filterByStories
    */

    filterByStories: function filterByStories(listings, params) {
        var storiesParam = _.find(params, { name: 'stories' });

        if(!storiesParam || !storiesParam.value) return listings;

        return _.filter(listings, function (listing) {
            if(storiesParam.value === '1') {
                return listing.floors === 1;
            } else {
                return listing.floors > 1;
            }
        });
    }
};

module.exports = listingFilters;
